import { useEffect } from "react";
import Notifications from "@/pages/Notifications";
export default function ProNotifications() { return <Notifications />; }
